import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { dateToStringFormat } from '@common/utils/date';
import { blockGradientColor } from '../../../utils/deployment-timeline/colors';
import { DeploymentPeriod } from '../../../models/organization/deployment';

const BAR_WIDTH_PX = 4;

const DeploymentPeriodCell: React.FC<{
  period: DeploymentPeriod | null | undefined;
  periodCount: number;
  isPeriodStart: boolean;
  isPeriodEnd: boolean;
}> = ({ period, periodCount, isPeriodStart, isPeriodEnd }) => {
  const { t } = useTranslation();

  if (period == null) return null;

  const color = blockGradientColor(period.index, periodCount);
  const span = `${dateToStringFormat(period.start, true)} - ${
    period.end == null
      ? t('info-label-ongoing')
      : dateToStringFormat(period.end, true)
  }`;

  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{ height: '100%', alignItems: 'stretch', width: '100%' }}
    >
      <Box
        data-testid="deployment-period-bar"
        sx={{
          width: `${BAR_WIDTH_PX}px`,
          flexShrink: 0,
          backgroundColor: color,
          borderTopLeftRadius: isPeriodStart ? BAR_WIDTH_PX : 0,
          borderTopRightRadius: isPeriodStart ? BAR_WIDTH_PX : 0,
          borderBottomLeftRadius: isPeriodEnd ? BAR_WIDTH_PX : 0,
          borderBottomRightRadius: isPeriodEnd ? BAR_WIDTH_PX : 0,
          my: isPeriodStart || isPeriodEnd ? 0.5 : 0,
        }}
      />
      {isPeriodStart && (
        <Stack sx={{ justifyContent: 'center', minWidth: 0 }}>
          <Typography variant="body2" noWrap sx={{ fontWeight: 600 }}>
            {period.rootOrganizationName}
          </Typography>
          <Typography variant="caption" noWrap sx={{ color: 'text.secondary' }}>
            {span}
          </Typography>
        </Stack>
      )}
    </Stack>
  );
};

export default DeploymentPeriodCell;
